const initialState = {
  isLoading: false,
};

/**
 * spinnerReducerTranslucent: Reducer to manage the loading state with a translucent overlay.
 * @param {any} state - The current state of the translucent loading spinner.
 * @param {any} action - The action to be processed.
 * @returns {any} - The updated state based on the action type.
 */

const spinnerReducerTranslucent = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_LOADING_STATE_TRANSLUCENT":
      return { isLoading: action?.payload };
      break;
    default:
      return state;
  }
};

export default spinnerReducerTranslucent;
